export default __webpack_public_path__ + "static/media/c8399b57fd2b85c29bc3ae8a47465539.svg";